import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // setTimeout nechá doběhnout SEO.jsx, který nastavuje document.title - jinak by Analytics zaznamenala titulek předchozí stránky
    setTimeout(() => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_path: pathname,
          page_location: window.location.href,
          page_title: document.title,
        });
      }
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
